/**
 * Return boolean indicating if debugging is enabled.
 */
export const debug = () => {
    if (process.env.NODE_ENV !== 'production') {
        const params = new URLSearchParams(location.search);
        return params.has('debug');
    }
    return false;
};
//# sourceMappingURL=debug.js.map